import React from 'react'

export default function NotFound() {
  return (
    <div>
      <h1 style={{textAlign: 'center', marginTop: '20%', fontSize: '60px', fontWeight : '800'}}>Error  404 Page Not Found !</h1>
    </div>
  )
}
